// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionMenu_root__6UJ_i","menu":"ActionMenu_menu___e_zb"};